import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white py-8 mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Contact Information */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-blue-300">Contact Information</h3>
            <div className="space-y-3">
              <div className="flex items-center">
                <svg className="w-5 h-5 mr-3 text-blue-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                <span className="text-gray-300">+82 10-8371-9886</span>
              </div>
              
              <div className="flex items-center">
                <svg className="w-5 h-5 mr-3 text-blue-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <a href="mailto:contact@calculushelper.com" className="text-gray-300 hover:text-blue-300 transition-colors">
                  khitmin1334@gmail.com
                </a>
              </div>
              
              <div className="flex items-center">
                <svg className="w-5 h-5 mr-3 text-blue-300" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8 0-1.12.23-2.18.65-3.15L12 15.5l7.35-6.65c.42.97.65 2.03.65 3.15 0 4.41-3.59 8-8 8z"/>
                </svg>
                <span className="text-gray-300">KakaoTalk ID: @khit134</span>
              </div>
            </div>
          </div>

          {/* About Section */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-blue-300">About Calculus Helper</h3>
            <p className="text-gray-300 text-sm leading-relaxed">
              Your comprehensive tool for mastering calculus concepts. From basic derivatives to advanced integration techniques, 
              we provide interactive learning experiences to help you succeed in your mathematical journey.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-blue-300">Quick Links</h3>
            <div className="space-y-2">
              <a href="#quiz" className="block text-gray-300 hover:text-blue-300 transition-colors text-sm">Practice Quiz</a>
              <a href="#explanations" className="block text-gray-300 hover:text-blue-300 transition-colors text-sm">Explanations</a>
              <a href="#level-test" className="block text-gray-300 hover:text-blue-300 transition-colors text-sm">Level Test</a>
              <a href="#old-questions" className="block text-gray-300 hover:text-blue-300 transition-colors text-sm">Past Questions</a>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-700 mt-8 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center">
            {/* Copyright */}
            <div className="text-gray-400 text-sm">
              © {new Date().getFullYear()} Calculus Helper. All rights reserved.
            </div>

            {/* Social Links / Additional Info */}
            <div className="flex items-center space-x-4 mt-4 md:mt-0">
              <span className="text-gray-400 text-sm">Made with ❤️ for calculus learners</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;